import React from 'react'
import {
  Row,
  Col,
  Modal,
  Form,
  Input,
  Button,
  InputNumber,
  Layout
} from 'antd'
import { Redirect } from 'react-router-dom'
import Header from '../../../../../Header'
import API from '../../../../../../api/index'

const { Content } = Layout

const InventoryCreate = (props) => {
  const id = props.match.params.id
  const name = props.match.params.name
  const branch = props.match.params.branch
  const trade = props.match.params.trade
  const [quantity, setQuantity] = React.useState(0)
  const [errorQuantity, setErrorQuantity] = React.useState(undefined)
  const [redirect, setRedirect] = React.useState(undefined)
 
  const onSubmit = async () => {
    clearErrors()
    if (quantity < 1) {
      Modal.error({
        title: 'Error',
        content: `La cantidad de producto no puede ser inferior a 1`
      })
    } else {
      const response = await API.inventory.create({
        product: id,
        quantity: quantity
      })
      if (response._id) {
        clearFields()
        Modal.success({
          title: 'Inventariar',
          content: `El producto ${name} fue inventariado exitosamente`
        })
        onBack()
      }
      if (response.errors) {
        makeErrors(response.errors)
      }
    }
  }

  const makeErrors = (error) => {
    if (error.quantity) {
      setErrorQuantity(error.quantity.message)
    }
  }

  const clearFields = () => {
    setQuantity(0)
    clearErrors()
  }

  const clearErrors = () => {
    setErrorQuantity(undefined)
  }

  const onBack = () => {
    setRedirect(`/inventorymerchant/${id}/${name}/${branch}/${trade}`)
  }
  if (redirect) {
    return (
      <Redirect to={redirect} />
    )
  }

  return (
    <Layout className='layout'>
      <Header item='branch' />
      <Content style={{ padding: '0 50px' }}>
        <div className='content-auto'>
          <Row style={{ marginBottom: '20px' }}>
            <Col span={8}>
              <h3><strong>Nuevo Inventario para {name}</strong></h3>
            </Col>
            <Col span={8} offset={8} style={{ textAlign: 'right' }}>
              <Button onClick={() => onBack()}>Regresar</Button>
              {' '}
              <Button onClick={() => onSubmit()}>Guardar</Button>
            </Col>
          </Row>
          <Form
            layout='vertical'
          >
            <Row>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Producto'
                >
                  <Input
                    disabled
                    value={name}
                  />
                </Form.Item>
              </Col>
              <Col span={7} offset={1}>
                <Form.Item
                  label='Cantidad del producto'
                  validateStatus={errorQuantity && ('error')}
                  help={errorQuantity}
                >
                  <InputNumber
                    min={0}
                    value={quantity}
                    onChange={(event) => setQuantity(event.target.value)} />
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </Content>
    </Layout>
  )
}

export default InventoryCreate
